import React from "react";
import { CHINTU_BEHAVIOUR, CHINTU_STORY_CARD } from "./chintuConfiguration";
import "./ChintuStoryCard.css";

/**
 * Chintu's ID card — opened by any button with `opens: "story"`.
 *
 * Laid out like a staff badge rather than a modal: portrait, name, made-up
 * designation, then the story. Content comes wholly from
 * CHINTU_STORY_CARD in chintuConfiguration.ts.
 */

interface ChintuStoryCardProps {
  onOk: () => void;
}

const ChintuStoryCard: React.FC<ChintuStoryCardProps> = ({ onOk }) => {
  const card = CHINTU_STORY_CARD;

  return (
    <div className="chintu-story" onClick={(event) => event.stopPropagation()}>
      <div className="chintu-story__badge">
        <div className="chintu-story__photo">
          <img src={CHINTU_BEHAVIOUR.faceSrc} alt="" draggable={false} />
        </div>
        <div className="chintu-story__ident">
          <span className="chintu-story__name">{card.name}</span>
          <span className="chintu-story__role">{card.role}</span>
          <span className="chintu-story__meta">{card.meta}</span>
        </div>
      </div>

      <div className="chintu-story__perforation" />

      <div className="chintu-story__body">
        {card.paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>

      {card.footnotes.length > 0 && (
        <div className="chintu-story__footnotes">
          {card.footnotes.map((note, index) => (
            <span key={index}>{note}</span>
          ))}
        </div>
      )}

      <button type="button" className="chintu-btn chintu-btn--accent" onClick={onOk}>
        {card.okLabel}
      </button>
    </div>
  );
};

export default ChintuStoryCard;
